import React from 'react';
import { Header, Placeholder } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';

import { Progress } from 'src/components/coreUI';
import { useAppSelector } from 'src/store';
import { PATH } from 'src/constants/app';
import { selectProgress } from 'src/store/model/class_topic';
import { hasStaffCourseAccess } from 'src/utils/courseCapabilities';

const Head: React.ForwardRefRenderFunction<HTMLDivElement> = (props, ref) => {
  const { class_id, class_topic_id } =
    useParams<{ class_id: string; class_topic_id: string }>();
  const { progress, class_user, expired_date } = useAppSelector((state) =>
    selectProgress(state, class_id!),
  );
  // A teacher has no enrolment: no progress to show, no expiry.
  const isTeacher = hasStaffCourseAccess(class_user?.class);

  const isInClassTopicContent = !!class_topic_id;

  return (
    <div ref={ref} className="layout_class_sider_head">
      {isInClassTopicContent ? (
        <Link
          to={{ pathname: `/${PATH.CLASS}/${class_id}` }}
          className="d-block fs-16 mb-16 cursor-pointer"
        >
          <span className="fs-22 mr-4">&lsaquo;</span>
          <span>Back to course home</span>
        </Link>
      ) : (
        <Link
          to={{ pathname: `${PATH.HOME}`, search: 'tab=my_courses' }}
          className="d-block fs-16 mb-16 cursor-pointer"
        >
          <span className="fs-22 mr-4">&lsaquo;</span>
          <span>Back to my courses</span>
        </Link>
      )}
      {class_user?.class?.name === undefined ? (
        <Placeholder>
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder>
      ) : (
        <Header className="mt-0 text-uppercase">
          {class_user?.class?.name}
        </Header>
      )}
      {!isTeacher && (
        <Progress
          percent={progress}
          labelClassName="fs-16 mb-4 d-block"
          renderLabel={(per) => (
            <div className="d-flex-between">
              <React.Fragment>
                <span>{`${per}% complete`}</span>
                {expired_date && <span> until {expired_date}</span>}
              </React.Fragment>
            </div>
          )}
        />
      )}
    </div>
  );
};

export default React.forwardRef(Head);
